import { types } from 'mobx-state-tree';

export const MetadataModel = types.model('MetadataModel', {
  key: types.string,
  value: types.string,
});
